import type {ComponentType} from 'react';
import {WorkflowStartScreen, type WorkflowStartScreenProps} from './workflow';


export const DefaultStartScreen: React.FC<{
  source: string;
  onSelectPrompt: (text: string) => void;
}> = ({source, onSelectPrompt}) => {
  return null;
};
export const startScreens: Record<
  string,
  ComponentType<{source: string; onSelectPrompt: (text: string) => void}>
> = {workflow: WorkflowStartScreen};
